import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { Projeto } from "../../types";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO } from "src/App";
import { notifierStore } from "src/framework/store/NotifierStore";

interface ModalCancelarProjetoParams {
    open: boolean;
    setOpenModal: Function;
    projeto?: Projeto;
    onSuccess: ()=>void;
}

const ModalCancelarProjeto: FC<ModalCancelarProjetoParams> = (modalCancelarProjetoParams) => {
    const [projetoState, setProjetoState] = useState<Projeto>();
    
    const handleClose = () => {
        modalCancelarProjetoParams.setOpenModal(false);
    };
    
    useEffect(() => {
        if (modalCancelarProjetoParams.open && modalCancelarProjetoParams?.projeto) {
            setProjetoState(modalCancelarProjetoParams.projeto);
        }
    }, [modalCancelarProjetoParams.open]);

    const doSave = async (): Promise<void> => {
        const data = { "projetos": [projetoState?.id] };
        const request: IDataRequest = {
            url: `/projetos/cancelar`,
            data: data
        }
        const response: IDataResponse = await api.post(request);
        if (response.statusCode === STATUS_CODE.OK) {
            if (projetoState) {
                projetoState.situacao = 'cancelado';
            }
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: ["Projeto cancelado com sucesso!"],
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false);
                    modalCancelarProjetoParams.onSuccess();
                    modalCancelarProjetoParams.setOpenModal(false);
                }
            });
            notifierStore.setOpen(true);
        } else {
            const content:string[] = [];
            content.push('Não foi possível cancelar o projeto.')
            if (response?.message) {
                if (Array.isArray(response?.message)) {
                    response?.message.forEach((m:string) => content.push(m));
                } else if (typeof response?.message === "string") {
                    content.push(response?.message);
                }
            }

            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: content,
                timeOut: 3500,
                onClose: () => {
                    const mensagemVigencia = content?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) || content?.some((message:any) => message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
                    if (mensagemVigencia) window.location.href = `${window.location.origin}/projetos/menu-projetos`;
                    notifierStore.setOpen(false);
                }
            });
            notifierStore.setOpen(true);
        }
    }

    return (
        <Dialog
            open={modalCancelarProjetoParams.open}
            onClose={handleClose}
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Atenção!</Box>
                            <Box component={"span"}>Cancelamento do projeto - {projetoState?.codigo_venda}</Box>
                            <Box component={"p"}>Ao cancelar um projeto, não será mais possível realizar nenhuma <br/>ação sobre ele</Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="inherit"
                    variant="contained"
                    disableElevation
                    text="Fechar"
                    onClick={handleClose}
                />
                <FlatButton
                    color="primary"
                    variant="contained"
                    disableElevation
                    text="Confirmar"
                    onClick={doSave}
                />
            </DialogActions>
        </Dialog>
    )
}

export { ModalCancelarProjeto }
